import { deepmerge } from "@mui/utils"
import { createTheme } from "@mui/material"
import _ from "lodash"

import { defaultThemeOptions } from "./default.theme"
import config from "../../config"

const DEVICE_UI_THEME_OPTION_FACTORIES = {}

/**
 *
 * @param {*} venueThemeOptions
 * @param {*} appThemeOptionFactory App Specific themeOption factory
 * @param {*} options // { extendThemeFactories: [], ignoreAppThemeFactory: boolean }
 * @returns
 */

const DEFAULT_OPTIONS = {
  extendThemeFactories: [],
  // When 'ignoreAppThemeFactory' is set to True, the merging of 'appThemeFactory' will be ignored.
  ignoreAppThemeFactory: false,
}

const breakpointsPreset = {
  default: {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  },
  //webapp will never trigger desktop layout
  mobile: {
    breakpoints: {
      values: {
        xs: 0,
        sm: 9999,
        md: 10000,
        lg: 10001,
        xl: 10002,
      },
    },
  },
}

export const generateTheme = (
  venueThemeOptions,
  appThemeOptionFactory,
  extendThemeOptions = DEFAULT_OPTIONS
) => {
  const {
    extendThemeFactories,
    ignoreAppThemeFactory,
    ignoreDeviceThemeFactory,
  } = _.merge(DEFAULT_OPTIONS, extendThemeOptions)

  // # Step 1: Create CoreThemeOptions (palette, typography, shadows, etc) by combining venue's themeOption with defaultCore.
  const { components: CoreThemeComponents = {}, ...CoreThemeOptions } =
    deepmerge(defaultThemeOptions, venueThemeOptions)
  const coreThemeOptionsWithBreakpoints = deepmerge(
    CoreThemeOptions,
    breakpointsPreset[config("breakpointsPreset")]
  )
  let theme = createTheme(coreThemeOptionsWithBreakpoints)
  // # Step 2: Add Base VenueUI themes for mobile, Vertical Kiosk (kiosk-v), and Horizontal Kiosk (kiosk-h) devices.
  const deviceThemeOptionFactory = _.get(
    DEVICE_UI_THEME_OPTION_FACTORIES,
    config("device")
  )

  if (!ignoreDeviceThemeFactory && !_.isNil(deviceThemeOptionFactory))
    theme = createTheme(theme, deviceThemeOptionFactory(theme))

  // # Step 3: Add App theme.
  if (!ignoreAppThemeFactory && !_.isNil(appThemeOptionFactory)) {
    theme = createTheme(theme, appThemeOptionFactory(theme))
  }

  // # Step 4: Add extension themes.
  if (!_.isEmpty(extendThemeFactories) && _.isArray(extendThemeFactories)) {
    for (const themeFactory of extendThemeFactories) {
      theme = createTheme(theme, themeFactory(theme))
    }
  }

  // # Step 5: Add Core Theme Components (Ensure that the venue's override component theme always applies.)
  theme = createTheme(theme, { components: CoreThemeComponents })

  return theme
}
